// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__qs4UE","heading":"firstFold_heading__0W2QC","subParagraph":"firstFold_subParagraph__0Jr9R"};